import React, { useEffect, useState } from "react";

import axiosInstance from "../../utils/axiosConfig";
import { BsArrowLeftSquare, BsArrowRightSquare } from "react-icons/bs";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { noTransaction } from "../../assets/images";
import { API_URL } from "../../constant";
import { useAuth } from "../../context/auth-context";
import { CiSearch } from "react-icons/ci";

const Merchants = ({ setOpenLog, setMerchantDeet, refetch }: any) => {
  const { isAuthenticated, query } = useAuth();
  const [page, setPage] = useState<number>(1);
  const [currentpage, setCurrentPage] = useState<number>();
  const [merchants, setMerchants] = useState<any[]>([]);
  const [sortedData, setSortedData] = useState<any[]>([]);
  const [merchantsLoader, setMerchantsLoader] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalMerchants, setTotalMerchants] = useState<number>(1);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc" | "">("");
  const [sortOrderKyc, setSortOrderKyc] = useState<"asc" | "desc" | "">("");
  const [sortOrderMail, setSortOrderMail] = useState<"asc" | "desc" | "">("");
  const [sortOrderDate, setSortOrderDate] = useState<"asc" | "desc" | "">("");
  const [status, setStatus] = useState<string>("all");
  const [searchTerm, setSearchTerm] = useState<string>("");

  useEffect(() => {
    if (!isAuthenticated) return; // Don't fetch before the session bootstrap has confirmed one

    setMerchantsLoader(true);

    const fetchData = async () => {
      try {
        const searchParam = searchTerm ? `&search=${searchTerm}` : "";
        const statusParam =
          status !== "all" ? `&status=${status.toUpperCase()}` : "";

        const { data } = await axiosInstance.get(
          `${API_URL}api/businesses/verifications?limit=25&page=${page}${searchParam}${statusParam}`
        );

        const sortedMerchant = data?.data?.businesses?.sort(
          (a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        // console.log(sortedMerchant);

        setMerchants(sortedMerchant);
        setTotalPages(data.data.meta.totalPages);
        setCurrentPage(data.data.meta.currentPage);
        setTotalMerchants(data.data.meta.totalRecords);
      } catch (error: any) {
        console.log(error.response?.data?.message || "An error occurred");
      } finally {
        setMerchantsLoader(false);
      }
    };

    const debounceTimer = setTimeout(fetchData, 600);

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, page, isAuthenticated, refetch, status]);

  useEffect(() => {
    if (sortOrder === "asc") {
      setSortedData(
        [...merchants].sort((a, b) => {
          const nameA = `${a.name} `;
          const nameB = `${b.name} `;
          return nameA.localeCompare(nameB);
        })
      );
    } else if (sortOrder === "desc") {
      setSortedData(
        [...merchants].sort((a, b) => {
          const nameA = `${a.name} `;
          const nameB = `${b.name} `;
          return nameB.localeCompare(nameA);
        })
      );
    } else {
      setSortedData(merchants);
    }
  }, [sortOrder, merchants]);
  useEffect(() => {
    if (sortOrderMail === "asc") {
      setSortedData(
        [...merchants].sort((a, b) => {
          const nameA = `${a.email}`;
          const nameB = `${b.email}`;
          return nameA.localeCompare(nameB);
        })
      );
    } else if (sortOrderMail === "desc") {
      setSortedData(
        [...merchants].sort((a, b) => {
          const nameA = `${a.email}`;
          const nameB = `${b.email}`;
          return nameB.localeCompare(nameA);
        })
      );
    } else {
      setSortedData(merchants);
    }
  }, [sortOrderMail, merchants]);

  useEffect(() => {
    if (sortOrderDate === "asc") {
      setSortedData(
        [...merchants].sort(
          (a, b) =>
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        )
      );
    } else if (sortOrderDate === "desc") {
      setSortedData(
        [...merchants].sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        )
      );
    } else {
      setSortedData(merchants);
    }
  }, [sortOrderDate, merchants]);

  useEffect(() => {
    const statusPriority: {
      [key in "PENDING" | "APPROVED" | "REJECTED"]: number;
    } = {
      PENDING: 0,
      APPROVED: 1,
      REJECTED: 2,
    };

    setSortedData(
      [...merchants].sort((a, b) => {
        const aLevel =
          statusPriority[a.status as "PENDING" | "APPROVED" | "REJECTED"] ?? 3;
        const bLevel =
          statusPriority[b.status as "PENDING" | "APPROVED" | "REJECTED"] ?? 3;

        if (sortOrderKyc === "asc") {
          return aLevel - bLevel; // Ascending order
        } else if (sortOrderKyc === "desc") {
          return bLevel - aLevel; // Descending order
        }
        return 0; // Default if sortOrderKyc doesn't match
      })
    );
  }, [sortOrderKyc, merchants]);

  // console.log(merchants);

  return (
    <div className="w-full   h-full">
      <div className="w-full pr-8 bg-[#0D0D0D] h-[67px] flex justify-between items-center">
        <div className="h-full flex justify-start items-center">
          <button
            onClick={() => setStatus("all")}
            className={
              status === "all"
                ? "h-full border-b-2  font-bold  text-[16px] text-secondary_button border-secondary_button px-4"
                : "h-full   text-[14px] text-gray-200 px-4"
            }
          >
            All logs
          </button>
          <button
            onClick={() => setStatus("Approved")}
            className={
              status === "Approved"
                ? "h-full border-b-2  font-bold  text-[16px] text-secondary_button border-secondary_button px-4"
                : "h-full   text-[14px] text-gray-200 px-4"
            }
          >
            Completed
          </button>
          <button
            onClick={() => setStatus("Rejected")}
            className={
              status === "Rejected"
                ? "h-full border-b-2  font-bold  text-[16px] text-secondary_button border-secondary_button px-4"
                : "h-full   text-[14px] text-gray-200 px-4"
            }
          >
            Rejected
          </button>
          <button
            onClick={() => setStatus("Pending")}
            className={
              status === "Pending"
                ? "h-full border-b-2  font-bold  text-[16px] text-secondary_button border-secondary_button px-4"
                : "h-full   text-[14px] text-gray-200 px-4"
            }
          >
            Requests
          </button>
        </div>
        <div className=" w-1/5  px-3 py-3 gap-2 rounded-xl bg-[#191919] flex justify-start items-center">
          <CiSearch className="text-[24px] text-gray-50 " />
          <input
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-11/12  text-gray-200 bg-transparent outline-none text-[14px]"
            placeholder="Search"
          />
        </div>
      </div>
      {merchantsLoader ? (
        <div className="lgss:flex hidden gap-5 w-full  h-[480px]">
          <div className="relative w-full space-y-3 overflow-hidden  bg-[#5c6b73] bg-opacity-30 p-8 shadow before:absolute before:inset-0 before:-translate-x-full before:bg-gradient-to-r before:from-transparent before:via-white/40 hover:shadow-lg before:animate-[shimmer_1.3s_infinite]">
            <div className="h-36 w-full  bg-[#E7EBEE]"></div>

            <div className="grid grid-cols-6 gap-2 mt-4">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-6 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-6 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-6 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-6 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-6 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
          </div>
        </div>
      ) : merchants.length >= 1 ? (
        <div>
          <div className="bg-[#0D0D0D] overflow-auto scrollbar-thumb-[#60B7F6] scrollbar-track-white   scrollbar-thin   w-full h-[652px]  ">
            <table className="w-full">
              <thead>
                <tr className="h-[56px] bg-[#1C2227] flex justify-start px-8  items-center ">
                  <th
                    onClick={() => {
                      if (sortOrder === "desc") {
                        setSortOrder("asc");
                      } else {
                        setSortOrder("desc");
                      }
                    }}
                    className="text-[#617889] gap-12 cursor-pointer mr-4 flex justify-start items-center text-[15px] w-1/5  whitespace-nowrap "
                  >
                    Name
                    <div className="flex flex-col justify-center items-center">
                      <TiArrowSortedUp
                        className={
                          sortOrder === "asc"
                            ? "text-[#BDBDBE] text-[14px]"
                            : "text-[#617889] text-[12px]"
                        }
                      />
                      <TiArrowSortedDown
                        className={
                          sortOrder === "desc"
                            ? "text-[#BDBDBE] text-[14px]"
                            : "text-[#617889] text-[12px]"
                        }
                      />
                    </div>
                  </th>
                  <th
                    onClick={() => {
                      if (sortOrderMail === "desc") {
                        setSortOrderMail("asc");
                      } else {
                        setSortOrderMail("desc");
                      }
                    }}
                    className="text-[#617889] gap-12 cursor-pointer mr-4 flex justify-start items-center text-[15px] w-1/5  whitespace-nowrap "
                  >
                    Email
                    <div className="flex flex-col justify-center items-center">
                      <TiArrowSortedUp
                        className={
                          sortOrderMail === "asc"
                            ? "text-[#BDBDBE] text-[14px]"
                            : "text-[#617889] text-[12px]"
                        }
                      />
                      <TiArrowSortedDown
                        className={
                          sortOrderMail === "desc"
                            ? "text-[#BDBDBE] text-[14px]"
                            : "text-[#617889] text-[12px]"
                        }
                      />
                    </div>
                  </th>
                  <th
                    onClick={() => {
                      if (sortOrderKyc === "desc") {
                        setSortOrderKyc("asc");
                      } else {
                        setSortOrderKyc("desc");
                      }
                    }}
                    className="text-[#617889] gap-6 cursor-pointer  flex justify-center items-center text-[15px] w-1/5  whitespace-nowrap "
                  >
                    KYC
                    <div className="flex flex-col justify-center items-center">
                      <TiArrowSortedUp
                        className={
                          sortOrderKyc === "asc"
                            ? "text-[#BDBDBE] text-[14px]"
                            : "text-[#617889] text-[12px]"
                        }
                      />
                      <TiArrowSortedDown
                        className={
                          sortOrderKyc === "desc"
                            ? "text-[#BDBDBE] text-[14px]"
                            : "text-[#617889] text-[12px]"
                        }
                      />
                    </div>
                  </th>

                  <th className="text-[#617889] text-[15px] w-1/5 mr-4 whitespace-nowrap text-left overflow-hidden">
                    Type
                  </th>
                  <th
                    onClick={() => {
                      if (sortOrderDate === "desc") {
                        setSortOrderDate("asc");
                      } else {
                        setSortOrderDate("desc");
                      }
                    }}
                    className="text-[#617889] gap-4 cursor-pointer flex mr-4 justify-start items-center text-[15px] w-1/5  whitespace-nowrap "
                  >
                    Date Created
                    <div className="flex flex-col justify-center items-center">
                      <TiArrowSortedUp
                        className={
                          sortOrderDate === "desc"
                            ? "text-[#BDBDBE] text-[12px]"
                            : "text-[#617889] text-[12px]"
                        }
                      />
                      <TiArrowSortedDown
                        className={
                          sortOrderDate === "asc"
                            ? "text-[#BDBDBE] text-[12px]"
                            : "text-[#617889] text-[12px]"
                        }
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              {sortedData.map((customer, index) => (
                <tbody
                  onClick={() => {
                    setMerchantDeet(customer);
                    setTimeout(() => {
                      setOpenLog(true);
                    }, 400);
                  }}
                  key={index}
                  className="cursor-pointer"
                >
                  <tr className="h-[56px] w-full flex justify-start  px-8  items-center">
                    <td className="text-white text-[15px] w-1/5 whitespace-nowrap capitalize mr-4 text-left overflow-hidden">
                      {customer.name}
                    </td>
                    <td className="text-white text-[15px] w-1/5 whitespace-nowrap mr-4 text-left overflow-hidden">
                      {customer.email}
                    </td>
                    <td className="flex items-center justify-center   w-1/5 text-[12px] font-bold">
                      <h4
                        className={
                          customer?.status === "APPROVED"
                            ? "text-[#03C668] font-bold text-[13px] cursor-pointer"
                            : customer?.status === "PENDING"
                            ? "text-[#F28A0F] font-bold text-[13px] cursor-pointer"
                            : customer?.status === "REJECTED"
                            ? "text-red-500 font-bold text-[13px] cursor-pointer"
                            : ""
                        }
                      >
                        {customer?.status}
                      </h4>
                    </td>
                    <td className="text-white text-[15px] w-1/5 whitespace-nowrap mr-4 text-left overflow-hidden">
                      {customer?.type}
                    </td>

                    <td className="text-white text-[15px] w-1/5 whitespace-nowrap mr-4 text-left overflow-hidden">
                      {(() => {
                        const dateString = customer.createdAt;
                        const date = new Date(dateString);

                        const day = date.getDate();
                        const ordinalSuffix = (day: number) => {
                          switch (day) {
                            case 1:
                            case 21:
                            case 31:
                              return "st";
                            case 2:
                            case 22:
                              return "nd";
                            case 3:
                            case 23:
                              return "rd";
                            default:
                              return "th";
                          }
                        };

                        const formattedDate = `${date.toLocaleString(
                          "default",
                          { month: "short" }
                        )} ${day}${ordinalSuffix(
                          day
                        )}, ${date.getFullYear()}, ${date.toLocaleString(
                          "default",
                          {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          }
                        )}`;

                        return formattedDate;
                      })()}
                    </td>
                  </tr>
                  <tr className="w-full">
                    <td className="mt-1 w-full h-[1px] bg-[#13181B]" />
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </div>
      ) : (
        <div className="w-full flex flex-col justify-start h-full mt-16 mb-20 items-center">
          <img src={noTransaction} alt="" />
          <h4 className="font-bold text-[#869AA9] pt-2">
            No {status !== "all" ? `${status.toLowerCase()}` : ""} merchant
          </h4>
          <p className=" text-[#869AA9] pt-2 text-[12px]">
            All {status !== "all" ? `${status.toLowerCase()}` : ""} merchants
            will show up here
          </p>
        </div>
      )}
      {merchants.length >= 1 && (
        <div className="flex gap-4 mt-14 justify-end items-center">
          <h4 className="font-bold font-sora text-[14px] text-white">
            Page {currentpage} of {totalPages}
          </h4>
          <button className="flex justify-center items-center">
            <BsArrowLeftSquare
              onClick={() => {
                if (page > 1) {
                  setPage((prev) => prev - 1);
                }
              }}
              className="text-3xl cursor-pointer text-[#C6D0D7] font-bold"
            />
          </button>

          <button>
            <BsArrowRightSquare
              onClick={() => {
                if (page < totalPages) {
                  setPage((prev) => prev + 1);
                }
              }}
              className="text-3xl cursor-pointer text-[#C6D0D7]"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default Merchants;
